import { useEffect } from "react";

export const useHeartbeat = (socket: any) => {
  useEffect(() => {
    // Listen for server-sent heartbeat
    const handleHeartbeat = () => {
      console.log("Heartbeat received from server");
      socket.emit("heartbeat_ack"); // Send acknowledgment back to server
      console.log("Heartbeat acknowledgment sent to server");
    };

    // Attach listener
    socket.on("heartbeat", handleHeartbeat);

    // Cleanup on unmount
    return () => {
      socket.off("heartbeat", handleHeartbeat);
    };
  }, [socket]);
};
